import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Box,
  Stack,
  Typography,
  FormHelperText,
  SelectChangeEvent,
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { CustomerListItem } from '../filter/companyFilterButton';


interface CompanyDropdownProps {
  error: boolean;
  helperText: string | undefined;
  onChange: (event: SelectChangeEvent<string>) => void;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  companyIdValue: string;
  companyList: CustomerListItem[];
}

const SelectCompany = ({
  error,
  helperText,
  onChange,
  onBlur,
  companyIdValue,
  companyList,
}: CompanyDropdownProps) => {
  let content = <p>Found no content.</p>;
  if (companyList.length >= 0) {
    content = (
      <Box sx={{ width: '100%' }}>
        <FormControl
          fullWidth
          variant='filled'
          sx={{           
            ...{
              minWidth: 120,
              w: {
                md: '444px',
                sm: '100%',
              },            
              '& .MuiPaper-rounded': {
                border: '1px solid #00000080',
              },
              '& .MuiPaper-root': {
                border: '1px solid #00000080',
              },
              '& .MuiPaper-elevation': {
                border: '1px solid #00000080',
              },
              '& .MuiMenu-paper': {
                border: '1px solid #00000080',
              },
              '& .MuiFilledInput-root:after': {
                border: 'none',
              },
              '& .MuiFilledInput-root:before': {
                borderBottom: 'none',
              },
              '& .MuiFilledInput-root:hover:not(.Mui-disabled,.Mui-error):before':
                {
                  borderBottom: 'none',
                },
              '& .report-type-menuitem': {
                margin: '0px',
              },
              '& .MuiButtonBase-root:hover': {
                backgroundColor: '#00CECF4D',
              },
              '& .MuiMenuItem-root:hover': {
                backgroundColor: '#00CECF4D',
              },
              '& .MuiButtonBase-root:active': {
                backgroundColor: '#00CECF4D',
              },
              '& .MuiMenuItem-root:active': {
                backgroundColor: '#00CECF4D',
              },
              '& .MuiMenuItem-root': {
                minHeight: '2.5rem',
              },
              '& .MuiFilledInput-root': {
                borderRadius: '6px',
              },              
              '& .MuiList-root-MuiMenu-list': {
                border: '1px solid #00000080',
                borderRadius: '6px',
              },
              '& .MuiList-padding': {
                border: '1px solid #00000080',
                borderRadius: '6px',
              },
              '& .MuiMenu-List': {
                border: '1px solid #00000080',
                borderRadius: '6px',
              },
            },
            ...(companyIdValue && {
              '& .MuiFilledInput-root': {
                backgroundColor: '#FFFFFF',
              },
              '& .MuiFilledInput-input:focus': {
                backgroundColor: '#FFFFFF',
              },
              '& .MuiFormLabel-root': {
                fontFamily: 'Schibsted Grotesk',
                fontSize: '12px',
                fontWeight: 400,
                lineHeight: '12px',
                letterSpacing: '0em',
                textAlign: 'left',
                left: '0.1rem',
                color: '#000000',
              },
              '& .MuiList-root': {
                border: '1px solid #00000080',
                borderRadius: '8px',
              },
              '& .MuiPopover-paper': {
                border: '1px solid #00000080',
                borderRadius: '8px',
              },

              '& .MuiFilledInput-input': {
                border: '1px solid #00000080',
                borderRadius: '6px',
              },
            }),
            ...(!companyIdValue && {
              '& .MuiFormLabel-root': {
                fontFamily: 'Schibsted Grotesk',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '17.28px',
                color: '#0000004D',
                left: '0.5rem',
              },
            }),
          }}
        >
          <InputLabel id='company-input-label'>Select Company</InputLabel>
          <Select
            displayEmpty={true}
            defaultValue={undefined}
            labelId='company-dropdown-label'
            id='company-dropdown'
            error={error}
            onChange={onChange}
            value={companyIdValue}
            name='company'
            onBlur={onBlur}
            IconComponent={(props) => (
              <ExpandMoreIcon
                {...props}
                sx={{
                  width: '30px',
                  height: '30px',
                }}
              />
            )}
          >
            {companyList.length > 0 &&
              companyList.map(({ id, slug, name }) => (
                <MenuItem
                  key={id}
                  value={slug}
                  sx={{
                    '&:hover': {
                      backgroundColor: 'rgba(0, 206, 207, 0.3)', // Change the background color on hover
                    },
                    '&.Mui-selected': {
                      backgroundColor: 'rgba(0, 206, 207, 0.3)', // Change the background color when selected
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'Schibsted Grotesk',
                      fontsize: '16px',
                      fontweight: 400,
                      lineHeight: '17px',
                      letterspacing: '0em',
                      textalign: 'left',
                    }}
                    variant='body2'
                    className='role-menuitem'
                  >
                    {name}
                  </Typography>
                </MenuItem>
              ))}
            {companyList.length === 0 && (
              <MenuItem value={'None'}>
                <p>None</p>
              </MenuItem>
            )}
          </Select>
        </FormControl>
        <FormHelperText
          sx={{
            color: error ? 'red' : 'inherit',
            paddingTop: '8px',
            paddingLeft: '10px',
          }}
        >
          {helperText}
        </FormHelperText>
      </Box>
    );
  }
  return (
    <Box sx={{ width: '100%' }}>
      <Stack
        direction='column'
        justifyContent='flex-start'
        alignItems='flex-start'
      >
        <Typography
          variant='caption'
          sx={{
            fontFamily: 'Schibsted Grotesk',
            fontSize: '0.875rem',
            fontWeight: 500,
            lineHeight: '1.0625rem',
            letterSpacing: '0em',
            textAlign: 'left',
            mb: 1.2,
          }}
        >
          Company
        </Typography>
        {content}
      </Stack>
    </Box>
  );
};

export default SelectCompany;
